export const API_BASE = process.env.REACT_APP_API_URL;
export const UPLOADS_BASE = (API_BASE || "").replace(/\/api\/?$/, "");
